import {useQuery} from "@tanstack/react-query";
import {Link} from "react-router-dom";
import {Card} from "./Card";
import "./PlaygroundCard.scss";
import VersionLabels from "core/components/common/version/VersionLabels";
import config from "../../../../../config";
import {CfgColors} from "core/config";
import {
    usePlaygroundDispatchApi,
    NAMESPACE_STATS_KEY,
} from "../../../../../api/playground/dispatch";

type PlaygroundCardPlayground = {
    namespace: string;
    playground_id: string;
    name: string;
    status: string;
    versions: any;
}

type PlaygroundCardProps = {
    playground: PlaygroundCardPlayground;
}

export function PlaygroundCard({playground}: PlaygroundCardProps) {
    var colours = config.get(CfgColors);
    var accentColor = playground.status === "OK" ? colours.upwireGreen2 : colours.upwireOrange1;

    var api = usePlaygroundDispatchApi();
    var {data: stats} = useQuery(
        [NAMESPACE_STATS_KEY, playground.namespace],
        () => api.getNamespaceStats(),
        {staleTime: 5 * 60 * 1000}
    );

    var mine = stats?.[playground.playground_id];
    var successCount = mine?.last24h.completed ?? "—";
    var failCount = mine?.last24h.failed ?? "—";

    return (
        <Card accentColor={accentColor}>
            <Link to={`/playground/${playground.namespace}/${playground.playground_id}`}
                  className="playground-card">
                <div className="start">
                    <div className="playground-label">
                        <span>{playground.name}</span>
                    </div>
                    <VersionLabels versions={playground.versions}/>
                </div>
                <div className="end">
                    <div className="pg-quick-stats">
                        <div className="stat">
                            <div className="stat-label success">{successCount}</div>
                            <div className="stat-legend">
                                <div>success</div>
                                <div>/24h</div>
                            </div>
                        </div>
                        <div className="stat">
                            <div className="stat-label failure">{failCount}</div>
                            <div className="stat-legend">
                                <div>failure</div>
                                <div>/24h</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </Card>
    );
}
